import React from 'react';

export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label className="block text-sm font-semibold text-slate-700">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        {...props}
        className={`w-full px-3.5 py-2.5 border rounded-lg text-sm bg-white
          focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent
          ${error ? 'border-red-400' : 'border-slate-300'}`}
      />
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}